import {
  CommentOutlined,
  FormatListBulletedRounded,
  StickyNote2Outlined,
  TrendingUpRounded,
} from "@mui/icons-material";
import { Box, Divider, Stack, SxProps, Tooltip, Typography, useTheme } from "@mui/material";
import { ActionItemSummaryDto } from "src/http";
import { Avatar, AvatarGroup, DueDateIcon, isWhitespace } from "..";
import { AzureDevOpsIcon } from "src/assets/icons";

interface IProps {
  actionItem: ActionItemSummaryDto;
  sx?: SxProps;
}

const ActionItemIcons = (props: IProps) => {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={0.25}
      divider={<Divider orientation="vertical" sx={{ height: "12px", borderColor: theme.palette.line.main }} />}
      sx={{
        alignItems: "center",
        ...props.sx,
      }}
    >
      {props.actionItem.owners.length > 0 && (
        <AvatarGroup
          max={2}
          sx={{
            "& .MuiAvatar-root": { width: 20, height: 20, fontSize: 12 },
          }}
          users={props.actionItem.owners}
          avatarComponent={(user) => <Avatar user={user} tooltip />}
        />
      )}

      {props.actionItem.note !== null && !isWhitespace(props.actionItem.note) && (
        <Tooltip title="Notes">
          <StickyNote2Outlined sx={{ color: "text.secondary" }} />
        </Tooltip>
      )}

      {props.actionItem.dueDate != null && <DueDateIcon dueDate={props.actionItem.dueDate} />}

      {props.actionItem.metricCount > 0 && (
        <Tooltip title="Metric">
          <TrendingUpRounded sx={{ color: "text.secondary" }} />
        </Tooltip>
      )}

      {props.actionItem.supportingItemsCount > 0 && (
        <Tooltip title="Supporting Items">
          <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
            <FormatListBulletedRounded sx={{ color: "text.secondary" }} />
            <Typography variant="caption">{props.actionItem.supportingItemsCount}</Typography>
          </Stack>
        </Tooltip>
      )}

      {props.actionItem.hasAzureDevOpsWorkItems && (
        <Tooltip title="Azure DevOps Work Items">
          <Box sx={{ alignItems: "center" }}>
            <AzureDevOpsIcon sx={{ color: "text.secondary", display: "flex" }} />
          </Box>
        </Tooltip>
      )}

      {props.actionItem.commentCount > 0 && (
        <Tooltip title="Comments">
          <Stack direction="row" spacing={0.1} sx={{ alignItems: "center" }}>
            <CommentOutlined sx={{ color: "text.secondary" }} />
            <Typography variant="caption">{props.actionItem.commentCount}</Typography>
          </Stack>
        </Tooltip>
      )}
    </Stack>
  );
};

export { ActionItemIcons };
